import { Route } from '../../../route-constants';
import { BreadCrumbItemProps } from '../../shared/components/EditTicketToolbar';
import { getViewIdFromStorage } from '../toolbar/CustomViewPopup/heplers/customPopupHelper';

type Translator = (key: string, options?: Record<string, unknown>) => string;

/**
 * Builds the breadcrumb items for the EditTicket toolbar based on
 * `history.location.state.from`.
 */
export const buildBreadcrumbItems = (
  historyState: { from?: string } | undefined,
  t: Translator
): BreadCrumbItemProps[] => {
  const defaultItems: BreadCrumbItemProps[] = [{ title: 'Tickets', link: '/' }];

  if (!historyState) return defaultItems;

  const localCustomViewId = getViewIdFromStorage('custom');
  const queryParam = localCustomViewId ? `?id=${localCustomViewId}` : '';

  switch (historyState.from) {
    case 'mywork':
      return [{ title: t('side-nav.my-work'), link: Route.myWork.pagePath }];
    case 'mygroupwork':
      return [{ title: t('side-nav.my-group-work'), link: Route.myGroupWork.pagePath }];
    case 'board':
      return [{ title: t('side-nav.ticket'), link: `/tickets/board${queryParam}` }];
    case 'list':
      return [{ title: t('side-nav.ticket'), link: `/tickets/list${queryParam}` }];
    default:
      return defaultItems;
  }
};
